import originalPartial from 'lodash/partial'

export default function partial(...args) {
  if (!args || !args[0]) { return null }

  return originalPartial.apply(null, args)
}



// WEBPACK FOOTER //
// ./client/utils/partial.js